import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./blogPage.css";

import blogData from "../../../../assets/Blogs/blogdata";

import Blog1 from "./blog1";
import Blog2 from "./blog2";
import Blog3 from "./blog3";
import Blog4 from "./blog4";
import Blog5 from "./blog5";
import Blog6 from "./blog6";
import Blog7 from "./blog7";
import Blog8 from "./blog8";
import Blog9 from "./blog9";
import Blog10 from "./blog10";
import Blog11 from "./blog11";
import Blog12 from "./blog12";
import Blog13 from "./blog13";
import Blog14 from "./blog14";
import Blog15 from "./blog15";
import Blog16 from "./blog16";
import Blog17 from "./blog17";
import Blog18 from "./blog18";

const BlogPageManager = () => {
  const { slug } = useParams();

  const currentBlog = blogData.find((item) => item.slug === slug);

  console.log("Slug from URL:", slug);
  console.log(
    "All slugs:",
    blogData.map((b) => b.slug),
  );

  if (!currentBlog) {
    return <div>Blog not found</div>;
  }

  const renderBlogComponent = () => {
    switch (currentBlog.id) {
      case 1:
        return <Blog1 blog={currentBlog} />;
      case 2:
        return <Blog2 blog={currentBlog} />;
      case 3:
        return <Blog3 blog={currentBlog} />;
      case 4:
        return <Blog4 blog={currentBlog} />;
      case 5:
        return <Blog5 blog={currentBlog} />;
      case 6:
        return <Blog6 blog={currentBlog} />;
      case 7:
        return <Blog7 blog={currentBlog} />;
      case 8:
        return <Blog8 blog={currentBlog} />;
      case 9:
        return <Blog9 blog={currentBlog} />;
      case 10:
        return <Blog10 blog={currentBlog} />;
      case 11:
        return <Blog11 blog={currentBlog} />;
      case 12:
        return <Blog12 blog={currentBlog} />;
      case 13:
        return <Blog13 blog={currentBlog} />;
      case 14:
        return <Blog14 blog={currentBlog} />;
      case 15:
        return <Blog15 blog={currentBlog} />;
      case 16:
        return <Blog16 blog={currentBlog} />;
      case 17:
        return <Blog17 blog={currentBlog} />;
      case 18:
        return <Blog18 blog={currentBlog} />;
      default:
        return <div>Blog not found</div>;
    }
  };

  return (
    <>
      <Helmet>
        <title>{currentBlog.metaTitle}</title>
        <meta name="description" content={currentBlog.metaDescription} />
        <meta
          name="keywords"
          content={`${currentBlog.primaryKeywords}, ${currentBlog.secondaryKeywords}`}
        />

        {/* Open Graph */}
        <meta property="og:title" content={currentBlog.metaTitle} />
        <meta property="og:description" content={currentBlog.metaDescription} />
        <meta property="og:image" content={currentBlog.detailImage} />
        <meta property="og:type" content="article" />

        {/* Twitter */}
        <meta name="twitter:title" content={currentBlog.metaTitle} />
        <meta
          name="twitter:description"
          content={currentBlog.metaDescription}
        />
        <meta name="twitter:image" content={currentBlog.detailImage} />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            headline: currentBlog.metaTitle,
            description: currentBlog.metaDescription,
            image: currentBlog.detailImage,
            datePublished: currentBlog.publishDate,
            author: {
              "@type": "Organization",
              name: "Kleio Innovation Labs",
            },
          })}
        </script>
      </Helmet>

      {renderBlogComponent()}
    </>
  );
};

export default BlogPageManager;
